module.exports = __webpack_public_path__ + "img/Mary_Scott.3b3fd03e.png";